// extracted by mini-css-extract-plugin
module.exports = {"label_for_context_text":"testForm_label_for_context_text__3GLOX","dialog_content":"testForm_dialog_content__Hl2cu","voice_input":"testForm_voice_input__13QTd"};